module.exports = __webpack_public_path__ + "static/media/software-image-pharmacist.b4ec6d71.png";